// extracted by mini-css-extract-plugin
export default {"container":"_2SOz8","status":"_3mR_r"};